import { Column } from './column.model'
import { Row } from './row.model';
import { InnerRow } from './inner-row.model';

export class Table {
  title: string;
  headerColumn: Column[] = [];
  row: Row[] = [];
  innerRow: InnerRow[] = [];

}
